import { render, staticRenderFns } from "./PaymentDataTable.vue?vue&type=template&id=b1995418&scoped=true"
import script from "./PaymentDataTable.vue?vue&type=script&lang=js"
export * from "./PaymentDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1995418",
  null
  
)

export default component.exports